import { render } from "./linkage.vue?vue&type=template&id=11d9c6aa"
import script from "./linkage.vue?vue&type=script&lang=js"
export * from "./linkage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\shared_space\\shared_agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__